import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { AutoBonusSummaryResponse } from "../../../domain/models/integration/auto-bonus-summary.model";
import { AutoBonusSummaryPort } from "../../../app/ports/integration/auto-bonus-summary.port";
import { EnvMicroIntegration } from "../../config/env.micro.integration";
import { INTEGRATION_ENV } from "../../config/micros-env.tokens";
import { isAutoBonusSummaryResponse } from "../../validators/integration/auto-bonus-summary.validator";

@Injectable()
export class AutoBonusSummaryHttpAdapter implements AutoBonusSummaryPort {
  constructor(
    private readonly http: HttpClient,
    @Inject(INTEGRATION_ENV) private readonly env: EnvMicroIntegration,
  ) {}

  getSummary(year: number, month: number, paidStatus: 0 | 1): Observable<AutoBonusSummaryResponse> {
    const baseUrl = `${this.env.host}${this.env.apiBasePath}`.replace(/\/$/, "");
    const path = `/api/v1/auto-bonus/periods/${year}/${month}/summary`;
    const params = new HttpParams().set("paidStatus", paidStatus);

    return this.http.get<unknown>(`${baseUrl}${path}`, { params }).pipe(
      map((response) => {
        if (!isAutoBonusSummaryResponse(response)) {
          throw new Error("La respuesta del resumen de Bono Auto es inválida.");
        }
        return response;
      }),
    );
  }
}
